export default __webpack_public_path__ + "static/media/icons_report_scan.a4b56982.svg";